/**
 * Deprecated bindHammer will be called by the init when
 */

import EventEmitter from "events";

export default class Swipe extends EventEmitter{

    constructor(){
        super();

        this.handleTouchStart = (evt) => {
            this.maglrLockAxis = null;
            this.maglrTouchDetection.xDown = evt.touches[0].clientX;
            this.maglrTouchDetection.yDown = evt.touches[0].clientY;
            this.maglrTouchDetection.startTime = new Date().getTime();
            this.maglrTouchDetection.speed = [[] ,[]];
            // this.maglrTouchDetection.speed[0] = x;
            // this.maglrTouchDetection.speed[1] = y;
        };

        this.handleTouchEnd = (evt) => {
            //NEEDED ?
        };
        this.getSpeed = ( x ) => {

        };
        this.handleTouchMove = (evt) => {

            let threshold = 100; //required min distance traveled to be considered swipe

            // console.log('# touchmove',this.maglrTouchDetection);
            if (!this.maglrTouchDetection.xDown || !this.maglrTouchDetection.yDown) {
                return;
            }

            let xDiff = this.maglrTouchDetection.xDown - evt.touches[0].clientX,
                yDiff = this.maglrTouchDetection.yDown - evt.touches[0].clientY,
                type = "none"
            ;
            let endTime = new Date().getTime();
            if(this.maglrTouchDetection._starter){
                this.maglrTouchDetection._starter = this.maglrTouchDetection.startTime;
            }
            // let elapsedTime = new Date().getTime() - this.maglrTouchDetection.startTime;
            // console.log('# MOVE: ', elapsedTime, this.maglrTouchDetection, threshold, restraint);
            //  if (elapsedTime <= allowedTime) {
            if(this.maglrLockAxis == null){
                if (Math.abs(xDiff) > Math.abs(yDiff)) {/*most significant*/
                    if(!this.maglrTouchDetection.startX){
                        this.maglrTouchDetection.startX = evt.touches[0].clientX;
                    }
                    if(this.maglrTouchDetection.speed[0].length > 150){ this.maglrTouchDetection.speed[0].shift(); }
                    this.maglrTouchDetection.speed[0].push(Math.abs(evt.touches[0].clientX-this.maglrTouchDetection.startX) / (endTime-this.maglrTouchDetection._starter));
                    this.maglrTouchDetection._starter = endTime;

                    if (xDiff > 0) {
                        /* left swipe */
                        type = "swipeleft";
                    } else {
                        /* right swipe */
                        type = "swiperight";
                    }
                } else {
                    if(!this.maglrTouchDetection.startY){
                        this.maglrTouchDetection.startY = evt.touches[0].clientY;
                    }
                    if(this.maglrTouchDetection.speed[1].length > 150){ this.maglrTouchDetection.speed[1].shift(); }
                    this.maglrTouchDetection.speed[1].push(Math.abs(evt.touches[0].clientY-this.maglrTouchDetection.startY) / (endTime-this.maglrTouchDetection._starter));
                    this.maglrTouchDetection._starter = endTime;
                    if (yDiff > 0) {
                        /* up swipe */
                        type = "swipeup";
                    } else {
                        /* down swipe */
                        type = "swipedown";
                    }
                }
                // if(Math.abs(xDiff) > thresholdSpeed && Math.abs(txDiff) > thresholdDistance ||
                //     Math.abs(yDiff) > thresholdSpeed &&  Math.abs(tyDiff) > thresholdDistance){
                // if(Math.abs(xDiff) > thresholdSpeed ||
                //     Math.abs(yDiff) > thresholdSpeed ){
                let averagexEnd = this._getArrayAVG(this.maglrTouchDetection.speed[0], 10),
                    averageyEnd = this._getArrayAVG(this.maglrTouchDetection.speed[1], 10);

                // console.log('# SPEED: ', averagexEnd, averageyEnd);

                if(Math.abs(xDiff) >= threshold && averagexEnd >= 0.5 || averagexEnd > 15 ||
                    Math.abs(yDiff) >= threshold && averageyEnd >= 0.5){
                    this.maglrLockAxis = type;
                    this.emit('swiped', type);
                }
            }

            /* reset values */
            // this.maglrTouchDetection.xDown = null;
            // this.maglrTouchDetection.yDown = null;
            // }
        };
    }

    init(hitArea){

        this.hitArea = hitArea || document;
        this.bindVanillaSwipe();

        return this;
    }

    bindVanillaSwipe(){
        // let pageWidth = window.innerWidth || document.body.clientWidth;
        // let thresholdSpeed = Math.max(1,Math.floor(0.02 * (pageWidth)));
        //check if we need fixed values
        // let threshold = Math.max(1,Math.floor(0.03 * (pageWidth))); //required min distance traveled to be considered swipe
        // let restraint = Math.floor(0.8 * (threshold) ); // maximum distance allowed at the same time in perpendicular direction
        // let threshold = 100; //required min distance traveled to be considered swipe
        // let restraint = 80; // maximum distance allowed at the same time in perpendicular direction
        // let allowedTime = 5000; // maximum time allowed to travel that distance


        // let thresholdSpeed = 4;
        // let thresholdDistance = 50;
        this.maglrLockAxis = null;

        this.maglrTouchDetection = {
            xDown: null,
            yDown: null,
            startTime: null
        };

        this.hitArea.removeEventListener('touchstart', this.handleTouchStart);
        this.hitArea.addEventListener('touchstart', this.handleTouchStart, { passive: true });
        this.hitArea.removeEventListener('touchmove', this.handleTouchMove);
        this.hitArea.addEventListener('touchmove', this.handleTouchMove, { passive: true });
        this.hitArea.removeEventListener('touchend', this.handleTouchEnd);
        this.hitArea.addEventListener('touchend', this.handleTouchEnd, { passive: true });
    }

    /**
     * get the average of the last `number` of array values of arr
     * @param arr
     * @param number
     * @returns {number}
     * @private
     */
    _getArrayAVG(arr, number){
        //taking `number` elements from the end to make the average
        let lastElements = arr.slice(number * -1);
        //get the average by summing the values and divide by length
        return Math.abs(lastElements.reduce( (a,b) => a + b, 0) / lastElements.length)
    }
}

